import React from "react";
import _ from "lodash";
import { BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";

import "./style.css";

// The trail runs eight crumbs deep at its worst — Domains / a domain / an
// organization / Users / an address / Edit — and most of those carry unbounded
// user data. Cap them; the full text stays on hover.
export const CRUMB_MAX = 20;

export const truncate = (text, max = CRUMB_MAX) =>
  text && text.length > max ? `${text.substring(0, max)}...` : text;

// `to` is optional: a few trails end in plain text rather than a link.
export const Crumb = ({ to, label, max = CRUMB_MAX }) => {
  const text = truncate(label, max);

  return (
    <BreadcrumbItem>
      {to ? (
        <Link to={to} title={label}>
          {text}
        </Link>
      ) : (
        <span title={label}>{text}</span>
      )}
    </BreadcrumbItem>
  );
};

// For a crumb that wants to show something the route params do not carry — a
// description in place of an id. The breadcrumb is mounted outside the content
// subtree, so the section's values are out of scope there; this asks again with
// the query and variables the content already uses, which Apollo answers from
// cache, and falls back until it does. `datapath` is relative to viewer.account,
// as in Section.Query.
export const useCrumbLabel = ({ query, variables, datapath, fallback }) => {
  const { data } = useQuery(query, { variables });

  return _.get(data, `viewer.account.${datapath}`) || fallback;
};
